import MultiStepForm from 'components/app-components/thera-start/MultiStepForm';
import AuthorizationCheck from 'components/container-components/allowedRoutes';
import { NextPage } from 'next';
import Head from 'next/head';
import Script from 'next/script';
import { useEffect } from 'react';
import { getWhiteLabelPageTitle } from 'utils/whiteLabelConfig';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

const TheraStart: NextPage = () => {
  useEffect(() => {
    if (!GTM_ID || typeof window === 'undefined') return;

    // Check if noscript already exists to avoid duplicates
    const existingNoscript = document.querySelector('noscript[data-gtm="incorporation"]');
    if (existingNoscript) return;

    // Create noscript element
    const noscript = document.createElement('noscript');
    noscript.setAttribute('data-gtm', 'incorporation');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    document.body.insertBefore(noscript, document.body.firstChild);

    // Cleanup function
    return () => {
      const noscriptToRemove = document.querySelector('noscript[data-gtm="incorporation"]');
      if (noscriptToRemove?.parentNode) {
        noscriptToRemove.parentNode.removeChild(noscriptToRemove);
      }
    };
  }, []);

  return (
    <>
      <Head>
        <title>{getWhiteLabelPageTitle('Thera Start | Thera')}</title>
        <meta name="description" content="Start your business incorporation with Thera" />
      </Head>

      {/* GTM Script */}
      {GTM_ID && (
        <Script
          id="gtm-incorporation"
          strategy="afterInteractive"
          // eslint-disable-next-line regex/invalid
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTM_ID}');
            `,
          }}
        />
      )}

      <div className={`min-h-screen w-full bg-[#181818] px-4 py-8 sm:px-6 md:px-8`}>
        <div className="relative mx-auto flex w-full max-w-[1186px] flex-col justify-center md:flex-row">
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default AuthorizationCheck(TheraStart);
